/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {signal} from '@preact/signals-react';
import {initialPerTabState} from './state';

export type TabPagination = {
  page: number;
  pageSize: number;
};

export type JobPaginationState = {
  [tabId: string]: TabPagination;
};

// the single source for "a tab nobody has paginated yet" - page 1 at the
// smallest page size, matching the grid's own initial request...
export const DEFAULT_PAGINATION: TabPagination = {
  page     : 1,
  pageSize : 20
};

export const jobPaginationState = signal<JobPaginationState>(
  initialPerTabState(() => ({...DEFAULT_PAGINATION}))
);

export const setJobPaginationState = (newState: JobPaginationState) => {
  jobPaginationState.value = newState;
};
